import { call, put } from 'redux-saga/effects'

import { toasts } from 'utils/toasts'

import { ChargeDataService } from 'services'

import * as actions from './chargeDataLogs.actions'
import i18next from 'i18next'

export function* fetchAll(action) {
  const { params } = action.payload

  const $chargeData = new ChargeDataService()
  const {
    success,
    status,
    data: logs
  } = yield call($chargeData.fetchLogs.bind($chargeData), params)

  if (status === 404) {
    return yield put(
      actions.setLogs({
        logs: { items: [], pagination: { totalItems: 0 } }
      })
    )
  } else if (success) {
    yield put(actions.setLogs({ logs }))
  } else {
    toasts.generalFail()
  }
}

export function* uploadFile(action) {
  const file = action.file
  const method = 'movimentacao'

  yield put(actions.clearUploadStatus())

  const $chargeData = new ChargeDataService()
  const response = yield call($chargeData.uploadFile.bind($chargeData), {
    file,
    method
  })

  if (response.success) {
    yield put(
      actions.setUploadStatus({
        status: 'success',
        message: i18next.t('chargeData:uploadSuccess'),
        errors: []
      })
    )
    yield put(actions.fetchAll())
  } else {
    let errorMessages = []
    if (
      response.data &&
      response.data.details &&
      response.data.details.validationErrors
    ) {
      // Extrair erros de validação da estrutura correta
      errorMessages = response.data.details.validationErrors
    } else if (response.data && response.data.validation) {
      errorMessages = response.data.validation
    } else if (response.message) {
      errorMessages = [response.message]
    } else {
      errorMessages = [i18next.t('chargeData:uploadError')]
    }

    yield put(
      actions.setUploadStatus({
        status: 'error',
        message: i18next.t('chargeData:uploadError'),
        errors: errorMessages
      })
    )
  }
}
